import {HomePageTabs, UserTypes} from "./Constants";

// This structure defines which of the home page sidebar tabs shows for each user type

export const ChildMenus = {
    MANAGER : 'manager',
    EDITOR : 'editor',
    CONTRIBUTOR: 'contributor',
}

export const ApplicationTypes = {
    POSTBOX : 1,
    MESSAGING: 2,
    COMMSPLANS: 3,
    POSTS: 4,
    DASHBOARD: 5,
    USERS: 6,
    RESOURCES:7,
    CONTACTS:8,
    CHILDREN:9,
    SYSADMIN: 10,
    MY_CONTRIBUTORS: 11,
    POSTBOX_APPROVER: 12,
    ORGANISATION_ADMIN: 13,
    SAFEGUARDING: 14,
    PRIVATE_MESSAGES: 15        // Indicates that the user can view private messages between users
}

export const HomePageMenus = {
    MY_CHILDREN : 1,
    MY_TEAM: 2,
    MY_ORGANISATION: 3,
    DASHBOARD: 4,
}

export const PostMenus = {
    MANAGER : 'manager',
    CONTRIBUTOR: 'contributor',
    CHILD: 'child'
}

export const MessagingMenus = {
    MANAGER : 'manager',
    CONTRIBUTOR: 'contributor'
}

export const DefaultChildViewPages = {
    DETAILS : 'details',
    POSTS: 'posts?type=new',
    MESSAGES: 'messaging?type=new'
}

export const DefaultChildImage = {
    AVATAR : 'avatar',
    DATABASE: 'database',
    DEFAULT: 'default'
}

// The phpVars structure now contains an array of application types based on the user_rights table
// To give a user rights for an applications module, you need to remove the application from userTypePermissions
// above, and add an entry in the user_rights table
//
// You also need to put the applicationType value in the rights table for the corresponging permission
// E.g. POSTBOX = 1

const userTypePermissions = {
    [UserTypes.ADMIN] : {
        tabs: [ HomePageTabs.HOME ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.SYSADMIN, ApplicationTypes.DASHBOARD, ApplicationTypes.USERS, ApplicationTypes.RESOURCES],
        defaultChildImage: DefaultChildImage.DATABASE,
        canCreateChildren: true,
    },
    [UserTypes.ARC_MANAGER] : {
        tabs: [ HomePageTabs.HOME ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.DASHBOARD, ApplicationTypes.COMMSPLANS, ApplicationTypes.MESSAGING, ApplicationTypes.POSTS,
            ApplicationTypes.USERS, ApplicationTypes.RESOURCES],
        childMenu: ChildMenus.MANAGER,
        messagingMenu: MessagingMenus.MANAGER,
        postMenu: PostMenus.MANAGER,
        defaultChildImage: DefaultChildImage.DATABASE,
        canCreateChildren: true
    },
    [UserTypes.ORG_MANAGER] : {
        tabs: [ HomePageTabs.HOME, HomePageTabs.TEAM , HomePageTabs.CHILDREN ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.COMMSPLANS, ApplicationTypes.MESSAGING, ApplicationTypes.POSTS,
            ApplicationTypes.USERS, ApplicationTypes.RESOURCES, ApplicationTypes.CONTACTS ],
        childMenu: ChildMenus.MANAGER,
        postMenu: PostMenus.MANAGER,
        messagingMenu: MessagingMenus.MANAGER,
        defaultChildImage: DefaultChildImage.DATABASE,
        canCreateChildren: true
    },
    [UserTypes.ARC_COORDINATOR] : {
        tabs: [ HomePageTabs.HOME ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.DASHBOARD, ApplicationTypes.COMMSPLANS, ApplicationTypes.MESSAGING, ApplicationTypes.POSTS,
            ApplicationTypes.USERS, ApplicationTypes.RESOURCES  ],
        childMenu: ChildMenus.MANAGER,
        postMenu: PostMenus.MANAGER,
        messagingMenu: MessagingMenus.MANAGER,
        defaultChildImage: DefaultChildImage.DATABASE,
        canCreateChildren: true
    },
    [UserTypes.FOSTER_PARENT] : {
        tabs: [ HomePageTabs.HOME ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.MESSAGING, ApplicationTypes.POSTS, ApplicationTypes.RESOURCES, ApplicationTypes.CONTACTS,
            ApplicationTypes.CHILDREN, ApplicationTypes.MY_CONTRIBUTORS],
        childMenu: ChildMenus.EDITOR,
        postMenu: PostMenus.MANAGER,
        messagingMenu: MessagingMenus.MANAGER,
        defaultChildImage: DefaultChildImage.DATABASE,
        canCreateChildren: false
    },
    [UserTypes.FOREVER_PARENT] : {
        tabs: [ HomePageTabs.HOME ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.MESSAGING, ApplicationTypes.POSTS, ApplicationTypes.RESOURCES, ApplicationTypes.CONTACTS,
            ApplicationTypes.CHILDREN, ApplicationTypes.MY_CONTRIBUTORS],
        childMenu: ChildMenus.EDITOR,
        postMenu: PostMenus.MANAGER,
        messagingMenu: MessagingMenus.MANAGER,
        defaultChildImage: DefaultChildImage.DATABASE,
        canCreateChildren: false
    },
    [UserTypes.PROFESSIONAL] : {
        tabs: [ HomePageTabs.HOME],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.MESSAGING, ApplicationTypes.POSTS, ApplicationTypes.RESOURCES, ApplicationTypes.CONTACTS,
            ApplicationTypes.CHILDREN],
        childMenu: ChildMenus.CONTRIBUTOR,
        postMenu: PostMenus.CONTRIBUTOR,
        messagingMenu: MessagingMenus.CONTRIBUTOR,
        defaultChildImage: DefaultChildImage.DEFAULT,
        canCreateChildren: false
    },
    [UserTypes.LIFE_STORY_WORKER] : {
        tabs: [ HomePageTabs.HOME, HomePageTabs.TEAM , HomePageTabs.CHILDREN ],
        applications: [ ApplicationTypes.COMMSPLANS, ApplicationTypes.MESSAGING, ApplicationTypes.POSTS, ApplicationTypes.USERS,
            ApplicationTypes.CONTACTS, ApplicationTypes.RESOURCES],
        homeTab: HomePageTabs.HOME,
        childMenu: ChildMenus.MANAGER,
        postMenu: PostMenus.MANAGER,
        messagingMenu: MessagingMenus.MANAGER,
        defaultChildImage: DefaultChildImage.DATABASE,
        canCreateChildren: true
    },
    [UserTypes.BIRTH_PARENT] : {
        tabs: [ HomePageTabs.HOME ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.MESSAGING, ApplicationTypes.POSTS, ApplicationTypes.CONTACTS, ApplicationTypes.CHILDREN ],
        childMenu: ChildMenus.CONTRIBUTOR,
        postMenu: PostMenus.CONTRIBUTOR,
        messagingMenu: MessagingMenus.CONTRIBUTOR,
        defaultChildImage: DefaultChildImage.DEFAULT,
        canCreateChildren: false
    },
    [UserTypes.OTHER] : {
        tabs: [ HomePageTabs.HOME ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.MESSAGING, ApplicationTypes.POSTS,  ApplicationTypes.CONTACTS, ApplicationTypes.CHILDREN ],
        childMenu: ChildMenus.CONTRIBUTOR,
        postMenu: PostMenus.CONTRIBUTOR,
        messagingMenu: MessagingMenus.CONTRIBUTOR,
        defaultChildImage: DefaultChildImage.DEFAULT,
        canCreateChildren: false
    },
    [UserTypes.CONNECTED_CARER] : {
        tabs: [ HomePageTabs.HOME],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.MESSAGING, ApplicationTypes.POSTS, ApplicationTypes.RESOURCES, ApplicationTypes.CONTACTS,
            ApplicationTypes.CHILDREN, ApplicationTypes.MY_CONTRIBUTORS],
        childMenu: ChildMenus.MANAGER,
        postMenu: PostMenus.MANAGER,
        messagingMenu: MessagingMenus.MANAGER,
        defaultChildImage: DefaultChildImage.DATABASE,
        canCreateChildren: false
    },
    [UserTypes.ORG_STAFF] : {
        tabs: [ HomePageTabs.HOME, HomePageTabs.TEAM ],
        homeTab: HomePageTabs.HOME,
        applications: [ApplicationTypes.MESSAGING, ApplicationTypes.CONTACTS],
        canCreateChildren: false
    },
    [UserTypes.CHILD] : {
        tabs: [ ],
        homeTab: HomePageTabs.HOME,
        applications: [ ApplicationTypes.MESSAGING, ApplicationTypes.POSTS, ApplicationTypes.CONTACTS],
        messagingMenu: MessagingMenus.CONTRIBUTOR,
        postMenu: PostMenus.CHILD,
        defaultChildImage: DefaultChildImage.DEFAULT,
        canCreateChildren: false
    },
}

const verifyUserType = ( userType ) =>
{
    if ( userTypePermissions[userType] === undefined )
    {
        throw new Error("Fatal: Invalid User Type");
    }

    if ( userTypePermissions[userType].tabs === undefined )
    {
        throw new Error("Fatal: Invalid tab configuration for user type");
    }

    if ( userTypePermissions[userType].homeTab === undefined )
    {
        throw new Error("Fatal: Invalid Home Tab configuration for user type");
    }
}

export const doesRoleHaveTab = ( tab, userType ) =>
{
    verifyUserType( userType ) ;

    return userTypePermissions[userType].tabs.includes(tab) ;
}

export const defaultTabForUser = ( userType ) =>
{
    verifyUserType ( userType );

    return userTypePermissions[userType].homeTab ;
}

/*export const getChildMenuTypeForUser = ( userType ) =>
{
    verifyUserType ( userType );

    return userTypePermissions[userType].childMenu ;
}*/

export const getPostMenuTypeForUser = ( userType ) =>
{
    verifyUserType ( userType );
    return userTypePermissions[userType].postMenu ;
}

export const getMessagingMenuTypeForUser = ( userType ) =>
{
    verifyUserType ( userType );

    return userTypePermissions[userType].messagingMenu ;
}

export const getDefaultChildViewPage = ( props ) =>
{
    let defaultChildPage = '';

    if(props.childDetails.is_manager || props.childDetails.is_editor){
        defaultChildPage = DefaultChildViewPages.DETAILS;
    }
    else if(props.childDetails.is_messager){
        defaultChildPage = DefaultChildViewPages.MESSAGES;
    }
    else{
        defaultChildPage = DefaultChildViewPages.POSTS;
    }

    return  defaultChildPage;
}

export const getDefaultContactViewPage = ( userType ) =>
{
    // verifyUserType ( userType );
    return 'messages';
}

export const doesUserHaveApplication = ( appType, userType ) =>
{
    verifyUserType ( userType );

    const { apps } = phpVars ;

    if ( userTypePermissions[userType].applications.includes(appType) )
    {
        // This applies applications for the hard-coded modules as defined in userTypePermissions.applications
        // Modules can be applied to individual users if required by adding them to the user_rights table

        return true ;
    }
    else if ( apps !== undefined && apps !== null && apps.includes(appType))
    {
        // The phpVars structure now contains an array of application types based on the user_rights table
        // To give a user rights for an applications module, you need to remove the application from userTypePermissions
        // above, and add an entry in the user_rights table
        //
        // You also need to put the applicationType value in the rights table for the corresponing permission
        // E.g. POSTBOX = 1

        return true ;
    }

    return false ;
}

//Used to checkk if a user is able to see the child's image/avatar as stored in database
//If not the user will see the systems default child icon
export const getDefaultChildImage = ( userType ) =>
{
    verifyUserType ( userType );

    return userTypePermissions[userType].defaultChildImage ;
}

//Used to check if a user is allowed to create children
export const getCanCreateChildren = ( userType ) =>
{
    verifyUserType ( userType );

    return userTypePermissions[userType].canCreateChildren ;
}

//LIF-1566 Check if user has application before making it a default
/*export const getDefaultChildApplication = ( userType ) =>
{
    const { apps } = phpVars ;

    if ( apps !== undefined && apps !== null && apps.includes(appType))

    return userTypePermissions[userType].defaultChildImage ;
}*/